__turbopack_context__.v({
  "statBoxWrapper": "StatBox-module-scss-module__Ofq-8W__statBoxWrapper",
});
